import React, { useState } from 'react';
import styled from 'styled-components';
import { Users, FileText, Calculator } from 'lucide-react';
import AdminRoute from './AdminRoute';
import UsersPage from './UsersPage';
import QuoteRequestsPage from './QuoteRequestsPage';
import PoleCalculationsPage from './PoleCalculationsPage';

const DashboardContainer = styled.div`
  min-height: 100vh;
  background: linear-gradient(135deg, #f5f8fb 0%, #ffffff 100%);
  padding: 2rem;
`;

const Header = styled.div`
  margin-bottom: 2rem;
`;

const Title = styled.h1`
  font-size: 2.5rem;
  font-weight: 700;
  color: var(--secondary-color);
  margin-bottom: 0.5rem;
`;

const Subtitle = styled.p`
  font-size: 1.125rem;
  color: var(--gray-600);
`;

const TabsContainer = styled.div`
  display: flex;
  gap: 1rem;
  margin-bottom: 2rem;
  border-bottom: 2px solid var(--gray-200);
  padding-bottom: 0;
`;

const Tab = styled.button`
  padding: 1rem 1.5rem;
  font-size: 1rem;
  font-weight: 600;
  color: ${props => props.$active ? 'var(--primary-color)' : 'var(--gray-600)'};
  background: none;
  border: none;
  border-bottom: 3px solid ${props => props.$active ? 'var(--primary-color)' : 'transparent'};
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: -2px;

  &:hover {
    color: var(--primary-color);
    background-color: var(--primary-light);
  }

  svg {
    width: 20px;
    height: 20px;
  }
`;

const ContentContainer = styled.div`
  background: white;
  border-radius: 16px;
  padding: 2rem;
  box-shadow: var(--shadow-md);
`;

const AdminDashboard = () => {
  const [activeTab, setActiveTab] = useState('users');

  const renderContent = () => {
    switch (activeTab) {
      case 'users':
        return <UsersPage />;
      case 'quotes':
        return <QuoteRequestsPage />;
      case 'calculations':
        return <PoleCalculationsPage />;
      default:
        return <UsersPage />;
    }
  };

  return (
    <AdminRoute>
      <DashboardContainer>
        <Header>
          <Title>Admin Dashboard</Title>
          <Subtitle>Manage users, quotes, and calculations</Subtitle>
        </Header>

        <TabsContainer>
          <Tab
            $active={activeTab === 'users'}
            onClick={() => setActiveTab('users')}
          >
            <Users />
            Users
          </Tab>
          <Tab
            $active={activeTab === 'quotes'}
            onClick={() => setActiveTab('quotes')}
          >
            <FileText />
            Quote Requests
          </Tab>
          <Tab
            $active={activeTab === 'calculations'}
            onClick={() => setActiveTab('calculations')}
          >
            <Calculator />
            Pole Calculations
          </Tab>
        </TabsContainer>

        <ContentContainer>
          {renderContent()}
        </ContentContainer>
      </DashboardContainer>
    </AdminRoute>
  );
};

export default AdminDashboard;
